var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "m-2" },
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "pay_box_sale-id",
                          label: _vm.$t("Id da venda"),
                        },
                        model: {
                          value: _vm.filters.saleId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "saleId", $$v)
                          },
                          expression: "filters.saleId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    [
                      _c("e-person-search", {
                        attrs: {
                          id: "pay_box_sale-client",
                          label: _vm.$t("Cliente"),
                          "is-customer": "",
                        },
                        model: {
                          value: _vm.filters.customer,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "customer", $$v)
                          },
                          expression: "filters.customer",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "pay_box_sale-origin",
                          label: _vm.$t("Origem"),
                          placeholder: _vm.$t("Selecione"),
                          type: "vue-select",
                          options: _vm.saleOriginOptions(),
                        },
                        model: {
                          value: _vm.filters.origin,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "origin", $$v)
                          },
                          expression: "filters.origin",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isPendingSaleLayout
                    ? _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "pay_box_sale-delivery_status",
                              label: _vm.$t("Status da entrega"),
                              placeholder: _vm.$t("Selecione"),
                              type: "vue-select",
                              options: _vm.deliveryStatusOptions(),
                            },
                            model: {
                              value: _vm.filters.deliveryStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "deliveryStatus", $$v)
                              },
                              expression: "filters.deliveryStatus",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "pay_box_sale-is_consigned",
                          type: "vue-select",
                          label: _vm.$t("Consignado"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.yesNoTypes(),
                        },
                        model: {
                          value: _vm.filters.isConsigned,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "isConsigned", $$v)
                          },
                          expression: "filters.isConsigned",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "pay_box_sale-period",
                          type: "date-range-picker",
                          label: _vm.$t("Período"),
                          opens: "right",
                        },
                        model: {
                          value: _vm.filters.period,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "period", $$v)
                          },
                          expression: "filters.period",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.filterData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "payBoxSale",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.tableEmptyMessage,
              fields: _vm.fields,
              items: _vm.isPendingSaleLayout ? _vm.pendingSales : _vm.sales,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(issueDate)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("datetime")(row.item.issueDate)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: {
                        status: row.item.status,
                        options: _vm.saleStatusOptions(),
                      },
                    }),
                  ]
                },
              },
              {
                key: "cell(deliveryStatus)",
                fn: function (row) {
                  return [
                    row.item.deliveryStatus
                      ? _c("e-status-badge", {
                          attrs: {
                            status: row.item.deliveryStatus,
                            options: _vm.deliveryStatusOptions(),
                          },
                        })
                      : _c("span", [_vm._v(" - ")]),
                  ]
                },
              },
              {
                key: "cell(delivery)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.delivery, type: "yesNo" },
                    }),
                  ]
                },
              },
              {
                key: "cell(consigned)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: {
                        status: row.item.consigned,
                        type: "yesNo",
                        "true-class-style":
                          row.item.pendingPaymentValue > 0 ? "warning" : "",
                        title:
                          row.item.consigned && row.item.pendingPaymentValue > 0
                            ? "Pendente de pagamento"
                            : "",
                      },
                    }),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "show-update": false,
                        "show-delete": false,
                        buttons: [
                          {
                            icon: "eye-fill",
                            variant: "primary",
                            title: _vm.$t("Visualizar venda"),
                            event: "show-sale-detail",
                          },
                        ],
                      },
                      on: {
                        "show-sale-detail": function ($event) {
                          return _vm.onShowSaleInfoSidebar(row.item)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "user-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("sale-info-sidebar", {
        ref: "saleInfoSidebar",
        attrs: { "is-pending-layout": _vm.isPendingSaleLayout },
        on: { "get-sale-data": _vm.getData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }